import request from '@/utils/request'

// 参会人员列表（V2 mini）
const LIST_MINI_PATH = '/meet/meetingCarryPeople/teev2/listMini'
// 新增会议携带人员
const API_PATH = '/meet/meetingCarryPeople'

const meetingCarryPeopleApi = {
  // 人员列表（分页）
  list(query) {
    return request.get(LIST_MINI_PATH, { params: query })
  },
  // 新增会议携带人员
  create(data) {
    return request.post(API_PATH, data)
  }
}

export default meetingCarryPeopleApi


